import { format, parseISO, isValid } from 'date-fns';

/**
 * An ISO date as `dd/MM/yyyy`. Returns the input untouched when it is not a date
 * — a malformed value from the API is worth showing rather than hiding behind
 * an empty cell.
 */
export function formatDate(iso: string): string {
  const parsed = parseISO(iso);
  return isValid(parsed) ? format(parsed, 'dd/MM/yyyy') : iso;
}
